module.exports = __webpack_public_path__ + "static/media/shoulder3Left.cfca210f.png";